import type { SVGProps } from "react";

export default function ListIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.66667 5.00121L17.5 5.00181M6.66667 10.0012L17.5 10.0019M6.66667 15.0012L17.5 15.0019M2.91667 5.00065H2.925M2.91667 10.0007H2.925M2.91667 15.0007H2.925M3.33333 5.00065C3.33333 5.23077 3.14678 5.41732 2.91667 5.41732C2.68655 5.41732 2.5 5.23077 2.5 5.00065C2.5 4.77053 2.68655 4.58398 2.91667 4.58398C3.14678 4.58398 3.33333 4.77053 3.33333 5.00065ZM3.33333 10.0007C3.33333 10.2307 3.14678 10.4173 2.91667 10.4173C2.68655 10.4173 2.5 10.2307 2.5 10.0007C2.5 9.77057 2.68655 9.58398 2.91667 9.58398C3.14678 9.58398 3.33333 9.77057 3.33333 10.0007ZM3.33333 15.0007C3.33333 15.2307 3.14678 15.4173 2.91667 15.4173C2.68655 15.4173 2.5 15.2307 2.5 15.0007C2.5 14.7706 2.68655 14.584 2.91667 14.584C3.14678 14.584 3.33333 14.7706 3.33333 15.0007Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
